import {
  Breadcrumb as AntdBreadcrumb,
  BreadcrumbProps as AntdBreadcrumbProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface BreadcrumbProps extends AntdBreadcrumbProps {}

export const breadcrumbPrefixCls = `${CMP_PREFIX}-breadcrumb`;

export const Breadcrumb = ({ ...props }: BreadcrumbProps) => {
  return <AntdBreadcrumb {...props} />;
};
